// One way to put a list of jobs in job-number order, used by every list that shows
// them so they all read the same.
//
// Two numbering series live side by side: jobs are four digits (2631) and standalone
// work orders are five (WO26114). Compared as plain numbers every work order
// leapfrogs every job, which buries the current work; compared as text "WO26114"
// lands before "2631". So the series are kept apart — jobs first, then work orders —
// and each is ordered highest first, because job numbers climb over time and these
// lists are opened to find current work.
//
// A work order filed under a master job (2325-WO001) carries the master's number, so
// it sorts with it rather than off in the work orders: the tie-break is ascending,
// which puts 2325 immediately above 2325-WO001.
const isWo = s => /^WO/i.test(String(s || '').trim());
const digitsOf = s => {
  const m = String(s || '').match(/\d+/);
  return m ? Number(m[0]) : -1;          // no number at all sinks to the bottom
};

export function byJobNumber(a, b) {
  const wa = isWo(a?.project_number) ? 1 : 0;
  const wb = isWo(b?.project_number) ? 1 : 0;
  if (wa !== wb) return wa - wb;                       // jobs above work orders

  const na = digitsOf(a?.project_number), nb = digitsOf(b?.project_number);
  if (na !== nb) return nb - na;                       // highest number first

  return String(a?.project_number || '').localeCompare(String(b?.project_number || ''));
}

export const sortByJobNumber = list => [...(list || [])].sort(byJobNumber);
